module.exports = require("./ne.js");